import * as React from "react";
const IconWindowRestore = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M42.9 16.1H8c-2.8 0-5 2.2-5 5V56c0 2.8 2.2 5 5 5h34.9c2.8 0 5-2.2 5-5V21.1c0-2.8-2.2-5-5-5M8 18.1h34.9c1.7 0 3 1.3 3 3v8.1H5v-8.1c0-1.6 1.3-3 3-3M42.9 59H8c-1.7 0-3-1.3-3-3V31.2h40.9V56c0 1.7-1.4 3-3 3" />
    <path d="M56 3H21.1c-2.8 0-5 2.2-5 5v1.1c0 .6.4 1 1 1s1-.4 1-1V8c0-1.7 1.3-3 3-3H56c1.7 0 3 1.3 3 3v34.9c0 1.7-1.3 3-3 3h-1.1c-.6 0-1 .4-1 1s.4 1 1 1H56c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5" />
  </svg>
);
export default IconWindowRestore;
